<template>
    <div class="row">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <h3 class="panel-title">Club Events</h3>
            </div>
            <table class="table table-bordered table-striped table-condensed">
                <thead>
                    <tr>
                        <th>&nbsp;</th>
                        <th>Event</th>
                        <th>Type</th>
                        <th class="text-center">Requires Volunteers</th>
                        <th>Start date</th>
                        <th>End date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(event, index) in events">
                        <td>
                            <button @click="editEvent(event)" class="btn btn-sm btn-primary"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button>
                            <button @click="removeEvent(event.id)" class="btn btn-sm btn-danger"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span></button>
                            <button @click="cloneEvent(event.id)" class="btn btn-sm btn-warning"><span class="glyphicon glyphicon-repeat" aria-hidden="true"></span></button>
                            <a :href="`/club/events/${event.id}/jobs`" class="btn btn-sm btn-success">Jobs</a>
                            <a :href="`/club/events/${event.id}/volunteers`" class="btn btn-sm btn-success">Volunteers</a>
                        </td>
                        <td>{{ event.club_event_name }}</td>
                        <td>{{ event.event_type }}</td>
                        <td class="text-center">
                            <span class="glyphicon glyphicon-ok text-success" v-if="event.requires_volunteers" aria-hidden="true"></span>
                            <span class="glyphicon glyphicon-remove text-danger" v-if="!event.requires_volunteers" aria-hidden="true"></span>
                        </td>
                        <td>{{ formatDate(event.start_date) }}</td>
                        <td>{{ formatDate(event.end_date) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>


</template>
<script>
    export default {
        data: function () {
            return {
                events: []
            }
        },

        mounted() {
            this.getClubEvents();
        },

        methods: {
            getClubEvents() {
                axios.get('/api/v1/club_events').then((response) => {
                    this.events = response.data;
                }).catch((error) => {
                    this.$message({message: 'There was a problem loading club events.', type: 'error'});
                });
            },

            formatDate(theDate) {
                return moment(theDate).format("DD/MM/YYYY")
            },

            removeEvent(id) {
                axios.delete(`/api/v1/club_events/${id}`)
                    .then(response => {
                        this.getClubEvents();
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem removing the event.', type: 'error'});
                    });
            },

            cloneEvent(id) {
                axios.post(`/api/v1/club_events/${id}/clone`)
                    .then(response => {
                        this.getClubEvents();
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem cloning the event.', type: 'error'});
                    });
            },
            editEvent(event) {
                this.$emit('event-edit', event);
            }
        },
    }
</script>
